import profile1 from '../../../Assets/Icons/cprofile1.png';
import profile2 from '../../../Assets/Icons/cprofile2.png';
import profile3 from '../../../Assets/Icons/cprofile3.png';
import profile4 from '../../../Assets/Icons/cprofile4.png';
import profile5 from '../../../Assets/Icons/cprofile5.png';
import profile6 from '../../../Assets/Icons/cprofile6.png';
import profile7 from '../../../Assets/Icons/cprofile7.png';



export const images = [
    {
        id:'1',
        img:profile1
    },
    {
        id:'2',
        img:profile2
    },
    {
        id:'3',
        img:profile3
    },
    {
        id:'4',
        img:profile4
    },
    {
        id:'5',
        img:profile5
    }, {
        id:'6',
        img:profile6
    }, {
        id:'7',
        img:profile7
    },

]
export const Desc = [
    {
        id:'1',
        comment:"But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account ",
        name:'Erin Schneider',
        job:'Designer at FileBox'
    },
    {
        id:'2',
        comment:"We are designing for a global user base with HostDesign we can get feedback not just from drivers we see in San Francisco  but from all around the world",
        name:'Alan Bridges',
        job:'Project Manager at Herby'
    },
    {
        id:'3',
        comment:"But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system",
        name:'Ashley Hunt',
        job:'Designer at Twitter'
    },
    {
        id:'4',
        comment:"We are designing for a global user base with HostDesign we can get feedback not just from drivers we see in San Francisco but from all around the world",
        name:'Ashley Hunt',
        job:'Designer at Twitter'
    },
    {
        id:'5',
        comment:"But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system",
        
        name:'Erin Schneider',
        job:'Designer at FileBox'
    },
    {
        id:'6',
        comment:"We are designing for a global user base with HostDesign we can get feedback not just from drivers we see in San Francisco  but from all around the world",
        name:'Alan Bridges',
        job:'Project Manager at Herby'
    },
    {
        id:'7',
        comment:"But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system",
        name:'Ashley Hunt',
        job:'Designer at Twitter'
    }
]